<template>
  <div id="nike-form">
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <div class="box">
          <h3 :style="cssProps">{{ $t("titles.modality") }}</h3>

          <!-- ESPORT -->
          <div class="item">
            <label
              >{{ $t("params.sport") }} <span class="obligatory">*</span>
              <span v-if="error.duplicated_weeks" class="obligatory">
                {{ $t("errors.duplicated_weeks") }}</span
              >
            </label>

            <div v-for="(campus, key) in campus_types" v-bind:key="campus.id">
              <div v-if="key == 'campus.football'">
                <template v-if="false">
                    <span>{{ $t("descriptions.nike_football") }}</span>

                    <v-checkbox
                    color="green"
                    class="text"
                    v-model="person.weeks"
                    v-bind:value="campus.weeks[Object.keys(campus.weeks)[0]].id"
                    @change="calculatePrice"
                    >
                    <template v-slot:label>
                        <span v-bind:class="error.person.weeks ? 'obligatory' : ''"
                        >
                        {{
                            campus.weeks[Object.keys(campus.weeks)[0]].name
                        }}</span
                        >
                    </template>
                    </v-checkbox>

                    <!-- <v-checkbox
                    color="green"
                    class="text"
                    v-model="person.weeks"
                    v-bind:value="campus.weeks[Object.keys(campus.weeks)[1]].id"
                    @change="calculatePrice"
                    >
                    <template v-slot:label>
                        <span v-bind:class="error.person.weeks ? 'obligatory' : ''"
                        >{{ $t("params.torn2") }} :
                        {{
                            campus.weeks[Object.keys(campus.weeks)[1]].name
                        }}</span
                        >
                    </template>
                    </v-checkbox> -->
                </template>
                
              </div>

              <div v-else>
                <v-checkbox
                  color="green"
                  class="text"
                  v-model="person.weeks"
                  v-bind:value="campus.weeks[Object.keys(campus.weeks)[0]].id"
                  @change="calculatePrice"
                >
                  <template v-slot:label>
                    <span v-bind:class="error.person.weeks ? 'obligatory' : ''"
                      >
                      {{
                        campus.weeks[Object.keys(campus.weeks)[0]].name
                      }}</span
                    >
                  </template>
                </v-checkbox>
              </div>

              <!--
                            <v-checkbox v-if="Object.keys(campus.weeks).length > 1" color="green" class="text" v-model="campus.checked" v-bind:value="campus.checked" @change="calculatePrice">
                                <template v-slot:label>
                                    <span v-bind:class="error.person.weeks ? 'obligatory' : ''">{{$t(key)}}</span>
                                </template>
                            </v-checkbox>
                            -->

              <!--
                            <v-checkbox v-else color="green" class="text" v-model="person.weeks" v-bind:value="campus.weeks[Object.keys(campus.weeks)[0]].id" @change="calculatePrice">
                                <template v-slot:label>
                                    <span v-bind:class="error.person.weeks ? 'obligatory' : ''">{{$t(key)}}: {{campus.weeks[Object.keys(campus.weeks)[0]].name}}</span>
                                </template>
                            </v-checkbox>
                            -->

              <!--
                            <div class="weeks" v-show="campus.checked" v-if="Object.keys(campus.weeks).length > 1" >
                                <v-autocomplete
                                :class="error.person.weeks ? 'error' : ''"
                                v-model="person.weeks"
                                :items="Object.values(campus.weeks)"
                                item-text="name"
                                item-value="id"
                                flat
                                multiple
                                :browser-autocomplete="'asd2saS<'"
                                ref="weeks"
                                hide-details
                                hide-selected
                                :placeholder="$t('params.campus_weeks')"
                                :auto-selected-first="true"
                                @change="calculatePrice"
                                >
                                <template v-slot:selection="data">
                                    <v-chip
                                    :selected="data.selected"
                                    close
                                    @input="removeWeek(data.item)"
                                    >
                                    {{ data.item.name }}
                                    </v-chip>
                                </template>
                                <template v-slot:item="data">
                                    <template v-if="typeof data.item !== 'object'">
                                    <v-list-tile-content v-text="data.item"></v-list-tile-content>
                                    </template>
                                    <template v-else>
                                    <v-list-tile-content>
                                        <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                                    </v-list-tile-content>
                                    </template>
                                </template>
                                </v-autocomplete>
                            </div>
                            -->
            </div>

            <div v-if="football_sport">
              <label
                >{{ $t("params.field_position") }}
                <span class="obligatory">*</span>
              </label>
              <select
                v-model="person.goalkeeper"
                :class="error.goalkeeper ? 'error' : ''"
              >
                <option disabled selected value="">
                  {{ $t("descriptions.field_position") }}
                </option>
                <option value="0">
                  {{ $t("params.field_player") }}
                </option>
                <option value="1">
                  {{ $t("params.goalkeeper") }}
                </option>
              </select>
              <!--
                            <v-radio-group v-model="person.goalkeeper" row>
                                <v-radio value="1">
                                    <template v-slot:label>
                                        <span>{{$t('si')}}</span>
                                    </template>
                                </v-radio>
                                <v-radio value="0">
                                    <template v-slot:label>
                                        <span>{{$t('no')}}</span>
                                    </template>
                                </v-radio>
                            </v-radio-group>
                            -->
            </div>
          </div>

          <!-- Modalitat -->
          <div class="item">
            <label
              >{{ $t("titles.modality") }}
              <span class="obligatory">*</span>
            </label>
            <v-radio-group
              v-model="person.modality"
              row
              @change="
                modalityChange();
                calculatePrice();
              "
            >
              <v-radio value="1">
                <template v-slot:label>
                  <span :class="error.person.modality ? 'obligatory' : ''">{{
                    $t("intern")
                  }}</span>
                </template>
              </v-radio>
              <v-radio value="2">
                <template v-slot:label>
                  <span :class="error.person.modality ? 'obligatory' : ''">{{
                    $t("extern")
                  }}</span>
                </template>
              </v-radio>
            </v-radio-group>
          </div>

          <h3 :style="cssProps">{{ $t("titles.player_nike") }}</h3>

          <!-- Nom -->
          <div class="item">
            <label
              >{{ $t("params.name") }} <span class="obligatory">*</span>
            </label>
            <input
              class="upper shadow"
              v-bind:class="error.person.name ? 'error' : ''"
              type="text"
              v-model="person.name"
              autocomplete="new-text"
            />
          </div>

          <!-- Cognom -->
          <div class="item">
            <label
              >{{ $t("params.surname") }} <span class="obligatory">*</span>
            </label>
            <input
              class="upper shadow"
              v-bind:class="error.person.surname ? 'error' : ''"
              type="text"
              v-model="person.surname"
              autocomplete="new-text"
            />
          </div>

          <!-- DNI -->
          <div class="item">
            <label
              >{{ $t("params.participant") }}
              <span class="obligatory">*</span>
              <span class="obligatory error" v-if="error.person.invalit_dni">{{
                " " + $t("errors.invalit_dni")
              }}</span>
              <span class="obligatory error" v-if="error.person.invalit_nie">{{
                " " + $t("errors.invalit_nie")
              }}</span>
              <span class="obligatory error" v-if="error.duplicated_dni">{{
                " " + $t("errors.same_dni")
              }}</span>
            </label>
            <div>
              <v-radio-group v-model="person.document_type" row>
                <v-radio :label="$t('params.dni')" value="1"></v-radio>
                <v-radio :label="$t('params.nie')" value="2"></v-radio>
                <v-radio :label="$t('params.passport')" value="3"></v-radio>
              </v-radio-group>
              <input
                v-if="person.document_type == '1'"
                v-bind:class="[
                  error.person.dni ? 'error' : '',
                  error.duplicated_dni ? 'error' : '',
                ]"
                type="text"
                v-model="person.dni"
                :placeholder="$t('params.dni') + '  ' + $t('params.dni_format')"
                class="upper shadow"
                autocomplete="new-text"
              />
              <input
                v-if="person.document_type == '2'"
                v-bind:class="[
                  error.person.dni ? 'error' : '',
                  error.duplicated_dni ? 'error' : '',
                ]"
                type="text"
                v-model="person.dni"
                :placeholder="$t('params.nie') + '  ' + $t('params.nie_format')"
                class="upper shadow"
                autocomplete="new-text"
              />
              <input
                v-if="person.document_type == '3'"
                v-bind:class="[
                  error.person.dni ? 'error' : '',
                  error.duplicated_dni ? 'error' : '',
                ]"
                type="text"
                v-model="person.dni"
                :placeholder="$t('params.passport')"
                class="upper shadow"
                autocomplete="new-text"
              />
            </div>
          </div>

          <!-- Birthday -->
          <div class="item" id="birthday">
            <label
              >{{ $t("params.birthday") }} <span class="obligatory">*</span>
              <span>
                {{
                  $t("campus.nike_age", {
                    a: min_age_sport(),
                    b: max_age_sport(),
                  })
                }}</span
              >
              <span> {{ $t("format") }}: (dd/mm/yyyy)</span>
              <span class="obligatory" v-if="error.person.invalit_birthday">
                {{
                  $t("errors.birthday_campus", {
                    a: min_age_sport(),
                    b: max_age_sport(),
                  })
                }}</span
              >
            </label>
            <!-- <input v-bind:class="error.person.birthday ? 'error' : ''" type="date" class="shadow" v-model="person.birthday" autocomplete="new-text"> -->

            <v-menu
              v-model="dialog_birthday"
              autocomplete="new-text"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
              :class="error.person.birthday ? 'error' : ''"
            >
              <template v-slot:activator="{ on }">
                <!--
                        <v-text-field
                        v-model="person.parsedBirthday"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                        class="shadow date-picker"
                        :class="error.person.birthday ? 'error' : ''"
                        ></v-text-field>
                        -->

                <!-- <v-btn @click="dialog_birthday = true">{{$t('params.birthday')}}</v-btn> -->
                <v-text-field
                  prepend-icon="event"
                  v-model="person.parsedBirthday"
                  @click:prepend="dialog_birthday = true"
                  :placeholder="'DD/MM/YYYY'"
                  :class="error.person.birthday ? 'error' : ''"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="person.birthday"
                @input="(dialog_birthday = false), formatBirthday()"
              ></v-date-picker>
            </v-menu>
          </div>

          <!-- Gender -->
          <div class="item">
            <label
              >{{ $t("params.gender") }} <span class="obligatory">*</span>
            </label>
            <v-radio-group v-model="person.gender" row>
              <v-radio value="1">
                <template v-slot:label>
                  <span :class="error.person.gender ? 'obligatory' : ''">{{
                    $t("gender.male")
                  }}</span>
                </template>
              </v-radio>
              <v-radio value="2">
                <template v-slot:label>
                  <span :class="error.person.gender ? 'obligatory' : ''">{{
                    $t("gender.female")
                  }}</span>
                </template>
              </v-radio>
            </v-radio-group>
          </div>

          <!-- Country -->
          <div class="item" id="country">
            <label>
              {{ $t("params.country") }} <span class="obligatory">*</span>
            </label>
            <v-autocomplete
              :class="error.person.country ? 'error' : ''"
              v-model="person.country_id"
              :items="Object.values(countries)"
              item-text="name"
              item-value="id"
              no-data
              :browser-autocomplete="'asd2saS<'"
              hide-no-data
            >
            </v-autocomplete>
          </div>

          <!-- Address -->
          <div class="item">
            <label
              >{{ $t("params.address") }} <span class="obligatory">*</span>
            </label>
            <input
              v-bind:class="error.person.address ? 'error' : ''"
              type="text"
              class="shadow"
              v-model="person.address"
              autocomplete="new-text"
            />
          </div>

          <!-- CP -->
          <div class="item">
            <label
              >{{ $t("params.cp") }} <span class="obligatory">*</span>
            </label>
            <input
              v-bind:class="error.person.cp ? 'error' : ''"
              type="text"
              class="shadow"
              v-model="person.cp"
              autocomplete="new-text"
            />
          </div>

          <!-- City -->
          <div class="item">
            <label
              >{{ $t("params.city") }} <span class="obligatory">*</span>
            </label>
            <input
              :class="error.person.city ? 'error' : ''"
              type="text"
              class="shadow"
              v-model="person.city"
              autocomplete="new-text"
            />
          </div>

          <!-- State -->
          <div class="item">
            <label
              >{{ $t("params.state") }} <span class="obligatory">*</span>
            </label>
            <input
              :class="error.person.state ? 'error' : ''"
              type="text"
              class="shadow"
              v-model="person.state"
              autocomplete="new-text"
            />
          </div>

          <!-- Phone -->
          <div class="item">
            <label
              >{{ $t("params.phone") }} <span class="obligatory">*</span>
              <span class="obligatory" v-if="error.person.invalit_phone">
                {{ $t("errors.phone") }}</span
              >
            </label>
            <vue-tel-input
              v-model="person.phone"
              @input="personPhone"
              autocomplete="new-text"
              style="border: none"
              :class="error.person.phone ? 'error' : ''"
              :placeholder="''"
              defaultCountry="ES"
              :inputOptions="{ showDialCode: true }"
            ></vue-tel-input>
          </div>

          <!-- Mobile -->
          <div class="item">
            <label
              >{{ $t("params.phone2") }} <span class="obligatory">*</span>
              <span class="obligatory" v-if="error.person.invalit_mobile">
                {{ $t("errors.phone") }}</span
              >
            </label>
            <vue-tel-input
              v-model="person.mobile"
              @input="personMobile"
              autocomplete="new-text"
              style="border: none"
              :class="error.person.mobile ? 'error' : ''"
              :placeholder="''"
              defaultCountry="ES"
              :inputOptions="{ showDialCode: true }"
            ></vue-tel-input>
          </div>

          <!-- Emergency Phone -->
          <!--
                    <div class="item">
                        <label>{{$t('params.emergency_phone')}} <span class="obligatory">*</span> <span class="obligatory" v-if="error.person.invalit_phone2"> {{$t('errors.phone')}}</span> </label>
                        <vue-tel-input v-model="person.phone2" @input="personPhone2" autocomplete="new-text" style="border:none" :class="error.person.phone2 ? 'error' : ''" :placeholder="''" defaultCountry="ES" ></vue-tel-input>
                    </div>
                    -->

          <!-- <h3 :style="cssProps">{{$t('titles.know_more')}}</h3> -->

          <!-- Medicamento -->
          <div class="item">
            <label>{{ $t("params.medicamento") }}</label>
            <input
              type="text"
              class="shadow"
              v-model="person.medicamento"
              :placeholder="$t('params.have_medicaments')"
              autocomplete="new-text"
            />
          </div>

          <div class="item"></div>

          <!-- Allergy -->
          <div class="item" id="alergy">
            <label>{{ $t("params.alergy") }}</label>
            <!--
                            <v-autocomplete
                            :class="error.alergy ? 'error' : ''"
                            v-model="person.alergy"
                            :items="Object.values(alergy)"
                            item-text="name"
                            item-value="id"
                            flat
                            multiple
                            :browser-autocomplete="'asd2saS<'"
                            ref="alergy"
                            hide-selected
                            hide-details
                            :placeholder="$t('params.have_allergy')"
                            @change="checkAlergies"
                            >
                            <template v-slot:selection="data">
                                <v-chip
                                :selected="data.selected"
                                close
                                @input="removeAlergy(data.item)"
                                >
                                {{ $t( 'alergy.' + data.item.name) }}
                                </v-chip>
                            </template>
                            <template v-slot:item="data">
                                <template v-if="typeof data.item !== 'object'">
                                <v-list-tile-content v-text="data.item"></v-list-tile-content>
                                </template>

                                <template v-else>
                                <v-list-tile-content>
                                    <v-list-tile-title> <v-checkbox></v-checkbox>  <span>{{$t('alergy.' + data.item.name)}}</span>  </v-list-tile-title>
                                </v-list-tile-content>
                                </template>

                            </template>
                            </v-autocomplete>
                            -->
            <v-select
              :class="error.alergy ? 'error' : ''"
              v-model="person.alergy"
              :items="Object.values(alergy)"
              item-text="name"
              item-value="id"
              multiple
              :browser-autocomplete="'asd2saS<'"
              ref="alergy"
              @change="checkAlergies"
              id="alergies"
              style="padding: 0"
              attach
              :menuProps="{
                closeOnClick: false,
                closeOnContentClick: true,
                maxHeight: 300,
                openOnClick: false,
              }"
            >
              <template v-slot:selection="{ item, index }">
                <v-chip @input="removeAlergy(item)">
                  {{ $t(item.name) }}
                </v-chip>
              </template>
              <!--
                            <template v-slot:item="data">
                                <template v-if="typeof data.item !== 'object'">
                                <v-list-tile-content v-text="data.item"></v-list-tile-content>
                                </template>

                                <template v-else>
                                <v-list-tile-content>
                                    <v-list-tile-title> <v-checkbox></v-checkbox>  <span>{{$t('alergy.' + data.item.name)}}</span>  </v-list-tile-title>
                                </v-list-tile-content>
                                </template>

                            </template>
                            -->
            </v-select>
          </div>

          <!-- Other allergies -->
          <div class="item">
            <label>{{ $t("params.other_allergies") }}</label>
            <input
              type="text"
              v-model="person.other_allergies"
              autocomplete="new-text"
            />
          </div>

          <!-- Diet -->
          <!-- <div class="item">
            <label>{{ $t("params.diet") }}</label>
            <select v-model="person.diet">
              <option v-for="(value, key) in diets" :key="key" :value="key">
                {{ $t(value.name) }}
              </option>
            </select>
          </div> -->

          <!-- Swim -->
          <div class="item">
            <label>{{ $t("swim") }} <span class="obligatory">*</span> </label>
            <v-radio-group v-model="person.swim" row>
              <v-radio value="1">
                <template v-slot:label>
                  <span :class="error.person.swim ? 'obligatory' : ''">{{
                    $t("si")
                  }}</span>
                </template>
              </v-radio>
              <v-radio value="2">
                <template v-slot:label>
                  <span :class="error.person.swim ? 'obligatory' : ''">{{
                    $t("no")
                  }}</span>
                </template>
              </v-radio>
            </v-radio-group>
          </div>

          <!-- Height -->
          <div class="item">
            <label
              >{{ $t("params.altura") }} <span class="obligatory">*</span>
            </label>
            <input
              v-bind:class="error.person.height ? 'error' : ''"
              type="number"
              class="shadow"
              v-model="person.height"
              autocomplete="new-text"
              pattern="[0-9]"
              @keypress="onlyNumber"
            />
          </div>

          <!-- How meet -->
          <div class="item">
            <label
              >{{ $t("params.how_meet_miccamp") }} <span class="obligatory">*</span>
            </label>
            <select
              class="shadow"
              v-bind:class="error.person.how_meet ? 'error' : ''"
              v-model="person.how_meet"
            >
              <option
                v-for="type in how_meet"
                v-bind:value="type.id"
                v-bind:key="type.id"
              >
                {{ $t(type.name) }}
              </option>
            </select>
          </div>

          <!-- Language -->
          <div class="item">
            <label
              >{{ $t("campus.communication") }}
              <span class="obligatory">*</span>
            </label>
            <v-radio-group
              v-model="person.language"
              row
              autocomplete="new-text"
            >
              <v-radio
                v-for="language in languages"
                v-bind:value="language.id"
                v-bind:key="language.id"
              >
                <template v-slot:label>
                  <span :class="error.person.language ? 'obligatory' : ''">
                    {{ language.name }}
                  </span>
                </template>
              </v-radio>
            </v-radio-group>
          </div>

          <!-- Lottery -->
          <div class="item">
            <label>{{ $t("params.lottery") }}</label>
            <v-checkbox v-model="person.lottery">
              <template v-slot:label>
                <span
                  v-html="$t('descriptions.lottery', { s: lottery_link })"
                ></span>
              </template>
            </v-checkbox>
          </div>

          <!-- Observacions -->
          <!--
                    <div class="item">
                        <label>{{$t('params.observacions')}} <span>{{$t('descriptions.observations')}}</span> </label>
                        <textarea type="text" v-model="person.observations" maxlength="255"></textarea>
                    </div>
                    -->
          <!-- TRANSPORT -->
          <h3 :style="cssProps">{{ $t("titles.transport") }}</h3>
          <!-- BUS -->
          <div class="item">
            <label
              >{{ $t("descriptions.nike_bus") }}
              <span class="obligatory">*</span>
            </label>
            <span class="info">{{ $t("descriptions.nike_bus_description") }}</span>
            <v-radio-group
              v-model="person.transport"
              row
              @change="calculatePrice"
            >
              <v-radio value="1">
                <template v-slot:label>
                  <span :class="error.person.transport ? 'obligatory' : ''">{{
                    $t("si")
                  }}</span>
                </template>
              </v-radio>
              <v-radio value="2">
                <template v-slot:label>
                  <span :class="error.person.transport ? 'obligatory' : ''">{{
                    $t("no")
                  }}</span>
                </template>
              </v-radio>
            </v-radio-group>
          </div>
          <div class="item"></div>
          <template v-if="person.transport == '1'">
            <div class="item">
              <label
                >{{ $t("descriptions.nike_bus_type") }}
                <span class="obligatory">*</span>
              </label>
              <select
                class="shadow"
                v-bind:class="error.person.bus ? 'error' : ''"
                v-model="person.bus"
                @change="calculatePrice"
              >
                <option
                  v-for="type in bus_options"
                  v-bind:value="type.id"
                  v-bind:key="type.id"
                >
                  {{ $t(type.name) }}
                </option>
              </select>
            </div>
            <template v-if="[1, 3].includes(person.bus)">
              <div class="item">
                <label
                  >{{ $t("titles.external") }}
                  <span class="obligatory">*</span>
                </label>
                <label v-if="[2, 3].includes(person.pickup)">
                  <span class="info"
                    >{{
                      $t(
                        person.pickup == 2
                          ? "campus.pickup.bcnsants_description"
                          : "campus.pickup.bcnairport_description"
                      )
                    }}
                  </span>
                </label>
                <select
                  class="shadow"
                  v-bind:class="error.person.pickup ? 'error' : ''"
                  v-model="person.pickup"
                >
                  <option
                    v-for="type in pickup_options"
                    v-bind:value="type.id"
                    v-bind:key="type.id"
                  >
                    {{ $t(type.name) }}
                  </option>
                </select>
              </div>
            </template>
            <template v-if="[2, 3].includes(person.bus)">
              <div v-if="person.bus == 3" class="item"></div>
              <div class="item">
                <label
                  >{{ $t("titles.returnit") }}
                  <span class="obligatory">*</span>
                </label>
                <label v-if="[2, 3].includes(person.returnit)">
                  <span class="info"
                    >{{
                      $t(
                        person.returnit == 2
                          ? "campus.returnit.bcnsants_description"
                          : "campus.returnit.bcnairport_description"
                      )
                    }}
                  </span>
                </label>
                <select
                  class="shadow"
                  v-bind:class="error.person.returnit ? 'error' : ''"
                  v-model="person.returnit"
                >
                  <option
                    v-for="type in pickup_options"
                    v-bind:value="type.id"
                    v-bind:key="type.id"
                  >
                    {{ $t(type.name) }}
                  </option>
                </select>
              </div>
            </template>
          </template>

          <h3 :style="cssProps">{{ $t("titles.player_tutor") }}</h3>

          <!-- Name -->
          <div class="item">
            <label
              >{{ $t("params.name") }} <span class="obligatory">*</span>
            </label>
            <input
              class="upper shadow"
              v-bind:class="error.legal_guardian.name ? 'error' : ''"
              type="text"
              v-model="legal_guardian.name"
              autocomplete="new-text"
            />
          </div>

          <!-- Surname -->
          <div class="item">
            <label
              >{{ $t("params.surname") }} <span class="obligatory">*</span>
            </label>
            <input
              class="upper shadow"
              :class="error.legal_guardian.surname ? 'error' : ''"
              type="text"
              v-model="legal_guardian.surname"
              autocomplete="new-text"
            />
          </div>

          <!-- DNI -->
          <div class="item">
            <label
              >{{ $t("params.parent_document") }}
              <span class="obligatory">*</span>
              <span
                class="obligatory error"
                v-if="error.legal_guardian.invalit_dni"
                >{{ " " + $t("errors.invalit_dni") }}</span
              >
              <span
                class="obligatory error"
                v-if="error.legal_guardian.invalit_nie"
                >{{ " " + $t("errors.invalit_nie") }}</span
              >
              <span class="obligatory error" v-if="error.duplicated_dni">{{
                " " + $t("errors.same_dni")
              }}</span>
            </label>
            <div>
              <v-radio-group v-model="legal_guardian.document_type" row>
                <v-radio :label="$t('params.dni')" value="1"></v-radio>
                <v-radio :label="$t('params.nie')" value="2"></v-radio>
                <v-radio :label="$t('params.passport')" value="3"></v-radio>
              </v-radio-group>
              <input
                v-if="legal_guardian.document_type == '1'"
                v-bind:class="[
                  error.legal_guardian.dni ? 'error' : '',
                  error.duplicated_dni ? 'error' : '',
                ]"
                type="text"
                v-model="legal_guardian.dni"
                :placeholder="$t('params.dni') + '  ' + $t('params.dni_format')"
                class="upper shadow"
                autocomplete="new-text"
              />
              <input
                v-if="legal_guardian.document_type == '2'"
                v-bind:class="[
                  error.legal_guardian.dni ? 'error' : '',
                  error.duplicated_dni ? 'error' : '',
                ]"
                type="text"
                v-model="legal_guardian.dni"
                :placeholder="$t('params.nie') + '  ' + $t('params.nie_format')"
                class="upper shadow"
                autocomplete="new-text"
              />
              <input
                v-if="legal_guardian.document_type == '3'"
                v-bind:class="[
                  error.legal_guardian.dni ? 'error' : '',
                  error.duplicated_dni ? 'error' : '',
                ]"
                type="text"
                v-model="legal_guardian.dni"
                :placeholder="$t('params.passport')"
                class="upper shadow"
                autocomplete="new-text"
              />
            </div>
          </div>

          <div class="item"></div>

          <!-- Emergency Phone -->
          <div class="item">
            <label
              >{{ $t("params.phone_number") }}
              <span class="obligatory">*</span>
              <span class="obligatory" v-if="error.person.invalit_phone2">
                {{ $t("errors.phone") }}</span
              >
            </label>
            <vue-tel-input
              v-model="person.phone2"
              @input="personPhone2"
              autocomplete="new-text"
              style="border: none"
              :class="error.person.phone2 ? 'error' : ''"
              :placeholder="''"
              defaultCountry="ES"
              :inputOptions="{ showDialCode: true }"
            ></vue-tel-input>
          </div>

          <!-- Email -->
          <div class="item">
            <label
              >{{ $t("params.email") }} <span class="obligatory">*</span>
              <span v-if="error.person.invalit_email" class="obligatory">
                {{ $t("errors.email") }}</span
              >
            </label>
            <input
              v-bind:class="error.person.email ? 'error' : ''"
              type="email"
              class="shadow"
              v-model="person.email"
              autocomplete="new-text"
            />
          </div>

          <h3 :style="cssProps">{{ $t("titles.total_cost") }}</h3>

          <!-- Total Cost -->
          <div class="item">
            <div id="price" v-if="Object.keys(person.services).length > 0">
              <div class="row">
                <span class="name">{{ $t("titles.total_cost") }}</span>
                <span class="value">{{ main_price }} &euro;</span>
              </div>
              <!-- <h5>{{$t('titles.total_cost')}}:</h5> -->
              <!-- <span v-if="main_price" >{{parseFloat(main_price) + parseFloat(total)}} &euro;</span> -->
              <div id="discounts-list">
                <div
                  class="row"
                  v-for="discount in person.total_discounts"
                  v-bind:key="discount.id"
                >
                  <span
                    class="name"
                    v-html="$t('descriptions.discount', { a: discount.code })"
                  ></span>
                  <span
                    class="clickable"
                    v-on:click="deleteDiscount(discount)"
                    >{{ $t("params.delete_discount") }}</span
                  >
                  <span v-if="discount.import == -99999" class="value">{{
                    $t("beca")
                  }}</span>
                  <span v-else class="value">{{ discount.import }} &euro;</span>
                </div>

                <div
                  class="row"
                  v-if="
                    person.brothers_discount &&
                    Object.keys(person.total_discounts).length < 2
                  "
                >
                  <span class="name">{{
                    $t("descriptions.brother_discount")
                  }}</span>
                  <span class="value"
                    >- {{ person.modality == 1 ? 15 : 15 }} &euro;</span
                  >
                </div>

                <div class="row" v-if="person.bus && import_bus > 0">
                  <span class="name">{{ $t("descriptions.bus_import") }}</span>
                  <span class="value">+ {{ import_bus }} &euro;</span>
                </div>

                <!-- <li v-if="person.repeater_discount && Object.keys(person.total_discounts).length < 2" v-html="$t('descriptions.repeater_discount',{a: repeater.value})"></li> -->
              </div>
              <div
                v-if="
                  person.brothers_discount ||
                  Object.keys(person.total_discounts).length > 0 ||
                  import_bus > 0
                "
                class="row total"
              >
                <span class="name">{{ $t("params.final_price") }}</span>
                <span class="value"
                  >{{ parseFloat(main_price) + parseFloat(total) }} &euro;</span
                >
              </div>
            </div>
            <div v-else>
              <p>{{ $t("errors.no_campus") }}</p>
            </div>
          </div>

          <!-- Discounts -->
          <div class="item">
            <label>
              <span>{{ $t("campus.max_discounts") }}</span>
              <span v-if="error.invalit_discount_code" class="obligatory">
                {{ $t("errors.invalit_discount_code") }}</span
              >
              <span v-if="error.duplicated_discount_code" class="obligatory">
                {{ $t("errors.duplicated_discount_code") }}</span
              >
              <span v-if="error.limit_discounts_code" class="obligatory">
                {{ $t("errors.limit_discounts_code") }}</span
              >
            </label>
            <v-checkbox
              v-if="!beca"
              v-model="person.brothers_discount"
              @change="brotherDiscount"
            >
              <template v-slot:label>
                <span
                  v-html="
                    $t('descriptions.brothers_discount', {
                      a: brother_boarder.value,
                      b: brother_no_boarder.value,
                    })
                  "
                ></span>
              </template>
            </v-checkbox>
            <div class="item" v-if="!beca">
              <input
                class="text"
                :class="
                  error.invalit_discount_code
                    ? 'error'
                    : '' || error.duplicated_discount_code
                    ? 'error'
                    : ''
                "
                v-model="person.discount"
                v-on:keyup.enter="applyDiscount"
              />
            </div>
            <div class="item" v-if="!beca">
              <button @click="applyDiscount" class="discount">
                {{ $t("params.discount") }}
              </button>
            </div>
          </div>

          <!-- Payment Method -->
          <div class="item">
            <label
              >{{ $t("params.payment_method") }}
              <span class="obligatory">*</span>
            </label>
            <!-- <span>{{$t('campus.payment_description')}}</span> -->
            <v-radio-group v-model="person.payment_type">
              <v-radio value="1">
                <template v-slot:label>
                  <span
                    :class="error.person.payment_type ? 'obligatory' : ''"
                    >{{ $t("campus.100") }}</span
                  >
                  <span v-if="main_price">
                    ({{
                      parseFloat(main_price) + parseFloat(total)
                    }}
                    &euro;)</span
                  >
                </template>
              </v-radio>
              <v-radio value="2" v-if="!disable_50">
                <template v-slot:label>
                  <span
                    :class="error.person.payment_type ? 'obligatory' : ''"
                    >{{ $t("campus.50") }}</span
                  >
                  <span v-if="main_price">
                    ({{
                      (parseFloat(main_price) + parseFloat(total)) / 2
                    }}
                    &euro;)</span
                  >
                </template>
              </v-radio>

              <!-- <v-radio value="3">
                <template v-slot:label>
                  <span
                    :class="error.person.payment_type ? 'obligatory' : ''"
                    >{{ $t("campus.bank") }}</span
                  >
                </template>
              </v-radio> -->
            </v-radio-group>
          </div>

          <div class="item"></div>

          <h3 :style="cssProps">{{ $t("titles.terms_and_conditions") }}</h3>

          <div>
            <!-- Information -->
            <div>
              <v-checkbox v-model="information" class="terms_and_conditions">
                <template v-slot:label>
                  <span> {{ $t("descriptions.information") }} </span>
                </template>
              </v-checkbox>
            </div>

            <!-- Termes i condicions -->
            <!--
                        <div>
                            <v-checkbox v-model="terms_and_conditions" class="terms_and_conditions">
                                <template v-slot:label>
                                    <span :class="error.terms_and_conditions ? 'obligatory' : ''" > {{$t('descriptions.terms_and_conditions_1')}} {{$t('descriptions.terms_and_conditions_2')}} </span>
                                </template>
                            </v-checkbox>
                             <button class="information" v-on:click="openDialog()" > {{$t('more_information')}} </button>
                        </div>
                        -->
            <!-- Política de privacitat -->
            <div>
              <v-checkbox v-model="privacy_policy" class="terms_and_conditions">
                <template v-slot:label>
                  <span :class="error.privacy_policy ? 'obligatory' : ''">
                    {{ $t("descriptions.privacy_policy_1") }}
                    <a target="_blank" :href="politicaPrivacidad">{{
                      $t("descriptions.privacy_policy_2")
                    }}</a>
                  </span>
                </template>
              </v-checkbox>
              <!-- <button class="information" v-on:click="openDialog($event)">
                {{ $t("more_information") }}
              </button> -->
            </div>

            <!-- Devolucions -->
            <div>
              <v-checkbox v-model="devolucions" class="terms_and_conditions">
                <template v-slot:label>
                  <span
                    v-bind:class="error.devolucions ? 'obligatory' : ''"
                    v-html="
                      $t('descriptions.devolucions', { s: devolucions_link })
                    "
                  ></span>
                </template>
              </v-checkbox>
            </div>

            <!-- captcha -->
            <span v-if="error.recaptcha" class="obligatory"
              >* {{ $t("errors.recaptcha") }}</span
            >
            <!-- <div class="g-recaptcha" :data-sitekey="captcha_key"></div> -->
            <vue-recaptcha
              :sitekey="captcha_key"
              @verify="recaptcha = true"
              :loadRecaptchaScript="true"
            ></vue-recaptcha>
          </div>

          <!-- Error Form -->
          <div>
            <span class="obligatory error-form" v-if="error.form">{{
              $t("errors.form")
            }}</span>
          </div>

          <!-- Send -->
          <button
            :style="cssButton"
            type="button"
            id="send"
            v-on:click="validate()"
            :disabled="button_dissabled"
          >
            {{ $t("continue") }}
          </button>

          <!-- Popup -->
          <v-dialog
            id="popup1_dialog"
            v-model="dialog"
            width="600"
            class="modal"
            :hide-overlay="true"
            data-app
          >
            <div id="popup1" class="body">
              <div class="header">
                <img
                  v-on:click="closeDialog()"
                  v-bind:src="'/img/error.svg'"
                  alt="delete"
                />
              </div>
              <div class="main">
                <p class="title">{{ $t("inscription-popup.title1") }}</p>
                <p>{{ "AGRUPACIO ESPORTIVA MICFOOTBALL" }}</p>

                <p class="title">{{ $t("inscription-popup.title2") }}</p>
                <!-- <p>{{$t('inscription-popup.part2', {s: 'ESPORTS AMB XARXA'})}}</p> -->
                <p>{{ $t("nike-popup.part2") }}</p>

                <p class="title">{{ $t("inscription-popup.title3") }}</p>
                <!-- <p>{{$t('inscription-popup.part3')}}</p> -->
                <p>{{ $t("nike-popup.part3") }}</p>

                <p class="title">{{ $t("inscription-popup.title4") }}</p>
                <!-- <p>{{$t('inscription-popup.part4')}}</p> -->
                <p>{{ $t("nike-popup.part4") }}</p>

                <p class="title">{{ $t("inscription-popup.title5") }}</p>
                <p>{{ $t("inscription-popup.part5") }}</p>

                <p class="title">{{ $t("inscription-popup.title6") }}</p>
                <p
                  v-html="
                    $t('inscription-popup.part6', {
                      s: politicaPrivacidad,
                    })
                  "
                ></p>
              </div>
            </div>
          </v-dialog>
        </div>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import i18n from "@/i18n";
import VueRecaptcha from "vue-recaptcha";

export default {
  name: "InscripcionNikeCampEn",

  components: {
    i18n,
    VueRecaptcha,
  },

  data() {
    return {
      person: {
        // sport: {},
        modality: "1",
        weeks: [],
        name: "",
        surname: "",
        dni: "",
        document_type: "1",
        birthday: "",
        parsedBirthday: "",
        gender: "",
        address: "",
        cp: "",
        city: "",
        state: "",
        phone: "",
        mobile: "",
        phone2: "",
        phone_aux: "",
        mobile_aux: "",
        phone2_aux: "",
        email: "",
        // observations: '',
        medicamento: "",
        alergy: "",
        swim: "",
        height: "",
        transport: false,
        bus: false,
        pickup: false,
        returnit: false,
        how_meet: "",
        language: "",
        lottery: false,
        discount: "",
        total_discounts: {},
        payment_type: "1",
        brothers_discount: false,
        services: {},
        repeater_discount: false,
        other_allergies: "",
        goalkeeper: -1,
        diet: "Z1NjenJhTWxQSmdjVkYwVG1JMVMrZz09",
        country_id: "",
      },
      legal_guardian: {
        name: "",
        surname: "",
        dni: "",
        document_type: "1",
      },
      error: {
        person: {
          sport: false,
          modality: false,
          weeks: false,
          name: false,
          surname: false,
          dni: false,
          invalit_dni: false,
          invalit_nie: false,
          birthday: false,
          gender: false,
          address: false,
          phone: false,
          mobile: false,
          phone2: false,
          invalit_phone: false,
          invalit_mobile: false,
          invalit_phone2: false,
          email: false,
          invalit_email: false,
          swim: false,
          transport: false,
          bus: false,
          pickup: false,
          returnit: false,
          how_meet: false,
          language: false,
          payment_type: false,
          invalit_birthday: false,
          cp: false,
          city: false,
          state: false,
          height: false,
          country: false,
          goalkeeper: false,
        },
        legal_guardian: {
          name: false,
          surname: false,
          dni: false,
          invalit_dni: false,
          invalit_nie: false,
        },
        // terms_and_conditions: false,
        privacy_policy: false,
        devolucions: false,
        recaptcha: false,
        form: false,
        duplicated_weeks: false,
        duplicated_discount_code: false,
        invalit_discount_code: false,
        limit_discounts_code: false,
        duplicated_dni: false,
      },
      alergy: {},
      campus_types: {},
      how_meet: {},
      languages: {},
      information: false,
      privacy_policy: false,
      dialog: false,
      lang: "",
      devolucions: false,
      devolucions_link: "",
      captcha_key: process.env.VUE_APP_CAPTCHA_KEY,
      lottery_link: "",
      total: 0,
      main_price: 0,
      import_bus: 0,
      nike_weeks: {},
      discounts: {},
      brother_boarder: {},
      brother_no_boarder: {},
      services: {},
      repeater: {},
      disable_50: false,
      button_dissabled: false,
      football_sport: false,
      diets: {},
      countries: {},
      dialog_birthday: false,
      min_age: { football: 11, basket: 11 },
      max_age: { football: 14, basket: 14 },
      recaptcha: false,
      beca: false,
      bus_options: [
        { id: 1, name: "campus.bus_type.go" },
        { id: 2, name: "campus.bus_type.back" },
        { id: 3, name: "campus.bus_type.both" },
      ],
      pickup_options: [
        { id: 1, name: "campus.pickup.bcncenter" },
        //{ id: 2, name: "campus.pickup.bcnsants" },
        { id: 3, name: "campus.pickup.bcnairport" },
      ],
    };
  },

  created() {
    var self = this;
    this.$overlay.loading();
    // get language
    this.lang = this.$route.params.lang;
    // check if isset
    if (!["ca", "es", "en"].includes(this.lang)) {
      this.lang = "ca";
    }
    i18n.loadLanguageAsync(this.lang).then(function () {
      // get form information
      self.$store
        .dispatch("getCampusInfo", { event_id: self.$route.params.event_id })
        .then(function () {
          self.alergy = JSON.parse(
            JSON.stringify(self.$store.getters["getAlergies"])
          );
          self.alergy["null"] = {
            id: "null",
            name: "no",
          };

          // update languages alergy
          for (let i in self.alergy) {
            self.alergy[i].name = i18n.t("alergy." + self.alergy[i].name);
          }

          self.person.alergy = ["null"];
          self.countries = self.$store.getters["getCountries"];
          self.how_meet = self.$store.getters["getHowMeet"];
          self.languages = self.$store.getters["getLanguages"];
          self.campus_types = JSON.parse(
            JSON.stringify(self.$store.getters["getCampusType"])
          );
          self.nike_weeks = self.$store.getters["getNikeWeeks"];
          self.discounts = self.$store.getters["getDiscounts"];
          self.services = self.$store.getters["getServices"];
          self.diets = self.$store.getters["getDiets"];

          // discounts
          for (let i in self.discounts) {
            // get boarder discount
            if (self.discounts[i].name.match("brothers_boarder")) {
              self.brother_boarder = { ...self.discounts[i] };
            }

            // get no boarder discount
            if (self.discounts[i].name.match("brothers_no-boarder")) {
              self.brother_no_boarder = { ...self.discounts[i] };
            }

            // get repeater discount
            if (self.discounts[i].name.match("repeater")) {
              self.repeater = { ...self.discounts[i] };
            }
          }
          // default language comunications
          for (let i in self.languages) {
            if (self.lang == self.languages[i].name) {
              self.person.language = i;
            }
          }

          self.$overlay.hide();
        })
        .catch(() => {
          self.$overlay.hide();
        });
    });

    switch (this.lang) {
      case "ca":
        this.devolucions_link =
          "https://miccamp.com/wp-content/uploads/2025/12/MC26_AND_TermCond_CAT.pdf?" + moment().valueOf();
        this.lottery_link =
          "https://miccamps.com/wp-content/uploads/2019/12/RIFA-CAT-2020.pdf";
        break;
      case "es":
        this.devolucions_link =
          "https://miccamp.com/wp-content/uploads/2025/12/MC26_AND_TermCond_ESP.pdf?" + moment().valueOf();
        this.lottery_link =
          "https://miccamps.com/wp-content/uploads/2019/12/RIFA-ESP-2020.pdf";
        break;
      case "en":
        this.devolucions_link =
          "https://miccamps.com/wp-content/uploads/2019/12/Politica-devoluciones-NC-ENG-1.pdf";
        this.lottery_link =
          "https://miccamps.com/wp-content/uploads/2019/12/RIFA-ENG-2020.pdf";
        break;
    }

    // dissable
    if (new Date() >= new Date("2026/06/01")) {
      this.disable_50 = true;
    }
  },

  methods: {
    validate() {
      let validate = true;

      // variable for campus_types
      let bCampusTypes = false;

      // loop for each campus types
      for (let i in this.campus_types) {
        // validate if campus type only has one week and is checked
        if (
          Object.keys(this.campus_types[i].weeks).length == 1 &&
          this.person.weeks.includes(Object.keys(this.campus_types[i].weeks)[0])
        ) {
          this.campus_types[i].checked = true;
        }

        // validate if campus is checked and has more than one week
        if (Object.keys(this.campus_types[i].weeks).length > 1) {
          // variable for validate if category is checked and doesn't have any week selected
          let selected = false;

          // loop for each week
          for (let n in this.campus_types[i].weeks) {
            // check if week is selected
            if (this.person.weeks.includes(this.campus_types[i].weeks[n].id)) {
              this.campus_types[i].checked = true;
              selected = true;
            }
          }

          // if category has weeks: selected, else don't selected
          selected
            ? (this.campus_types[i].checked = true)
            : (this.campus_types[i].checked = false);
        }

        // validate if campus is checked
        if (this.campus_types[i].checked) {
          bCampusTypes = true;
        }
      }

      // error campus
      if (!bCampusTypes) {
        this.error.person.sport = true;
        validate = false;
      } else {
        this.error.person.sport = false;
      }

      // person.modality
      if (isEmpty(this.person.modality)) {
        this.error.person.modality = true;
        validate = false;
      } else {
        this.error.person.modality = false;
      }

      // weeks
      if (this.person.weeks.length < 1) {
        this.error.person.weeks = true;
        validate = false;
      } else {
        if (this.validateDuplicatedWeeks()) {
          this.error.person.weeks = false;
          this.error.duplicated_weeks = false;
        } else {
          this.error.person.weeks = true;
          this.error.duplicated_weeks = true;
        }
      }

      // check if sport is football and validate player field type
      if (this.football_sport && isEmpty(this.person.goalkeeper)) {
        this.error.goalkeeper = true;
        validate = false;
      } else {
        this.error.goalkeeper = false;
      }

      // name
      if (isEmpty(this.person.name)) {
        this.error.person.name = true;
        validate = false;
      } else {
        this.error.person.name = false;
      }

      // surname
      if (isEmpty(this.person.surname)) {
        this.error.person.surname = true;
        validate = false;
      } else {
        this.error.person.surname = false;
      }

      // dni nie passport
      if (isEmpty(this.person.dni)) {
        this.error.person.dni = true;
        validate = false;
      } else {
        // dni
        if (this.person.document_type == "1") {
          // remove error nie
          this.error.person.invalit_nie = false;
          // validate dni
          if (!validateDocument(this.person.dni, 1)) {
            this.error.person.invalit_dni = true;
            this.error.person.dni = true;
            validate = false;
            // valit document
          } else {
            this.error.person.invalit_dni = false;
            this.error.person.dni = false;
          }
        }
        // nie
        if (this.person.document_type == "2") {
          // remove error dni
          this.error.person.invalit_dni = false;
          // validate nie
          if (!validateDocument(this.person.dni, 2)) {
            this.error.person.invalit_nie = true;
            this.error.person.dni = true;
            validate = false;
            // valit document
          } else {
            this.error.person.invalit_nie = true;
            this.error.person.dni = false;
          }
        }
      }

      // birthday
      if (
        isEmpty(this.person.birthday) ||
        this.person.parsedBirthday.trim().length != 10
      ) {
        this.error.person.birthday = true;
        validate = false;
      } else {
        if (this.validateYear()) {
          this.error.person.birthday = false;
          this.error.person.invalit_birthday = false;
        } else {
          this.error.person.birthday = true;
          this.error.person.invalit_birthday = true;
          validate = false;
        }
      }

      // gender
      if (isEmpty(this.person.gender)) {
        this.error.person.gender = true;
        validate = false;
      } else {
        this.error.person.gender = false;
      }

      // country
      if (isEmpty(this.person.country_id)) {
        this.error.person.country = true;
        validate = false;
      } else {
        this.error.person.country = false;
      }

      // address
      if (isEmpty(this.person.address)) {
        this.error.person.address = true;
        validate = false;
      } else {
        this.error.person.address = false;
      }

      // cp
      if (isEmpty(this.person.cp)) {
        this.error.person.cp = true;
        validate = false;
      } else {
        this.error.person.cp = false;
      }

      // city
      if (isEmpty(this.person.city)) {
        this.error.person.city = true;
        validate = false;
      } else {
        this.error.person.city = false;
      }

      // state
      if (isEmpty(this.person.state)) {
        this.error.person.state = true;
        validate = false;
      } else {
        this.error.person.state = false;
      }

      // phone
      if (Object.keys(this.person.phone_aux).length > 0) {
        // validate if club mobile is valid
        if (this.person.phone_aux.isValid) {
          // ok save phone
          this.person.phone = this.person.phone_aux.number.e164;
          // remove  errors
          this.error.person.phone = false;
          this.error.person.invalit_phone = false;
          // invalit mobile number
        } else {
          this.error.person.invalit_phone = true;
          this.error.person.phone = true;
          validate = false;
        }
        // empty mobile
      } else {
        this.error.person.phone = true;
        validate = false;
      }

      // mobile
      if (Object.keys(this.person.mobile_aux).length > 0) {
        // validate if club mobile is valid
        if (this.person.mobile_aux.isValid) {
          // ok save phone
          this.person.mobile = this.person.mobile_aux.number.e164;
          // remove  errors
          this.error.person.mobile = false;
          this.error.person.invalit_mobile = false;
          // invalit mobile number
        } else {
          this.error.person.invalit_mobile = true;
          this.error.person.mobile = true;
          validate = false;
        }
        // empty mobile
      } else {
        this.error.person.mobile = true;
        validate = false;
      }

      // emergency phone
      if (Object.keys(this.person.phone2_aux).length > 0) {
        // validate if club mobile is valid
        if (this.person.phone2_aux.isValid) {
          // ok save phone
          this.person.phone2 = this.person.phone2_aux.number.e164;
          // remove  errors
          this.error.person.phone2 = false;
          this.error.person.invalit_phone2 = false;
          // invalit mobile number
        } else {
          this.error.person.invalit_phone2 = true;
          this.error.person.phone2 = true;
          validate = false;
        }
        // empty mobile
      } else {
        this.error.person.phone2 = true;
        validate = false;
      }

      // email
      if (isEmpty(this.person.email)) {
        this.error.person.email = true;
        validate = false;
        // validate email
      } else {
        // valit email
        if (validateEmail(this.person.email)) {
          this.error.person.email = false;
          this.error.person.invalit_email = false;
          // invalit email
        } else {
          validate = false;
          this.error.person.email = true;
          this.error.person.invalit_email = true;
        }
      }

      // observacions
      // if(isEmpty(this.person.observations)) this.person.observations = ''

      // medicamento
      if (isEmpty(this.person.medicamento)) this.person.medicamento = "";

      // swim
      if (isEmpty(this.person.swim)) {
        this.error.person.swim = true;
        validate = false;
      } else {
        this.error.person.swim = false;
      }

      // height
      if (isEmpty(this.person.height)) {
        this.error.person.height = true;
        validate = false;
      } else {
        this.error.person.height = false;
      }

      // how meet
      if (isEmpty(this.person.how_meet)) {
        this.error.person.how_meet = true;
        validate = false;
      } else {
        this.error.person.how_meet = false;
      }

      // language
      if (isEmpty(this.person.language)) {
        this.error.person.language = true;
        validate = false;
      } else {
        this.error.person.language = false;
      }

      // Responsable name
      if (isEmpty(this.legal_guardian.name)) {
        this.error.legal_guardian.name = true;
        validate = false;
      } else {
        this.error.legal_guardian.name = false;
      }

      // Responsable surname
      if (isEmpty(this.legal_guardian.surname)) {
        this.error.legal_guardian.surname = true;
        validate = false;
      } else {
        this.error.legal_guardian.surname = false;
      }

      // Responsable dni
      if (isEmpty(this.legal_guardian.dni)) {
        this.error.legal_guardian.dni = true;
        validate = false;
      } else {
        this.error.legal_guardian.invalit_dni = false;
        this.error.legal_guardian.invalit_nie = false;
        // dni
        if (this.legal_guardian.document_type == "1") {
          // remove error nie
          this.error.legal_guardian.invalit_nie = false;
          // validate dni
          if (!validateDocument(this.legal_guardian.dni, 1)) {
            this.error.legal_guardian.invalit_dni = true;
            // valit document
          } else {
            this.error.legal_guardian.invalit_dni = false;
            this.error.legal_guardian.dni = false;
          }
        }
        // nie
        if (this.legal_guardian.document_type == "2") {
          // remove error dni
          this.error.legal_guardian.invalit_dni = false;
          // validate nie
          if (!validateDocument(this.legal_guardian.dni, 2)) {
            this.error.legal_guardian.invalit_nie = true;
            // valit document
          } else {
            this.error.legal_guardian.invalit_nie = true;
            this.error.legal_guardian.dni = false;
          }
        }
      }

      // lottery
      this.person.lottery
        ? (this.person.lottery = 1)
        : (this.person.lottery = 0);

      // brothers discount

      // discounts

      // payment_type
      if (isEmpty(this.person.payment_type)) {
        this.error.person.payment_type = true;
        validate = false;
      } else {
        this.error.person.payment_type = false;
      }

      // termes i condicions
      /*
            if(!this.terms_and_conditions){
                this.error.terms_and_conditions = true;
                validate = false;
            } else {
                this.error.terms_and_conditions = false;
            }
            */

      // política de privacitat
      if (!this.privacy_policy) {
        this.error.privacy_policy = true;
        validate = false;
      } else {
        this.error.privacy_policy = false;
      }

      // política de devolucions
      if (!this.devolucions) {
        this.error.devolucions = true;
        validate = false;
      } else {
        this.error.devolucions = false;
      }

      // google recaptcha
      // try {
      //     // validate recaptcha
      //     if(!grecaptcha.getResponse()){
      //         this.error.recaptcha = true;
      //         validate = false;
      //     } else {
      //         this.error.recaptcha = false;
      //     }
      // } catch(error) {
      //     this.error.recaptcha = false;
      // }

      if (!this.recaptcha) {
        this.error.recaptcha = true;
        validate = false;
      } else {
        this.error.recaptcha = false;
      }

      // validate if dni from participant is different from the legal guardian
      if (
        !isEmpty(this.person.dni) &&
        !isEmpty(this.legal_guardian.dni) &&
        this.person.dni == this.legal_guardian.dni
      ) {
        this.error.duplicated_dni = true;
        // this.error.person.dni = true;
        // this.error.legal_guardian.dni = true;
        validate = false;
      } else {
        this.error.duplicated_dni = false;
        // this.error.person.dni = false;
        // this.error.legal_guardian.dni = false;
      }

      //bus
      if (this.person.transport) {
        this.error.person.transport = false;
        if (this.person.transport == "1") {
          if (!this.person.bus) {
            this.error.person.bus = true;
            validate = false;
          } else {
            this.error.person.bus = false;
          }
          if ([1, 3].includes(this.person.bus) && !this.person.pickup) {
            this.error.person.pickup = true;
            validate = false;
          } else {
            this.error.person.pickup = false;
          }
          if ([2, 3].includes(this.person.bus) && !this.person.returnit) {
            this.error.person.returnit = true;
            validate = false;
          } else {
            this.error.person.returnit = false;
          }
        }
      } else {
        validate = false;
        this.error.person.transport = true;
      }

      if (validate) {
        this.button_dissabled = true;

        // alergy
        if (this.person.alergy.length == 1 && this.person.alergy[0] == "null")
          this.person.alergy = [];

        // check if selected brother discount, and doesn't have more than 2 discounts
        if (
          this.person.brothers_discount &&
          Object.keys(this.person.total_discounts).length < 2
        ) {
          // check modality
          this.person.modality == 1
            ? // boarder
              (this.person.total_discounts[this.brother_boarder.id] = {})
            : // no boarder
              (this.person.total_discounts[this.brother_no_boarder.id] = {});
        }

        // check if repeater discount, and doesn't have more than 2 discounts
        if (
          this.person.repeater_discount &&
          Object.keys(this.person.total_discounts).length < 2
        ) {
          this.person.total_discounts[this.repeater.id] = {};
        }

        var self = this;
        this.$overlay.loading();
        this.$store
          .dispatch("joinNikeCampus", {
            event_id: self.$route.params.event_id,
            participant_campus: self.person.weeks,
            participant_modality: self.person.modality,
            participant_name: self.person.name,
            participant_surname: self.person.surname,
            participant_dni: self.person.dni,
            participant_document_type: self.person.document_type,
            participant_birthday: self.person.birthday,
            participant_gender: self.person.gender,
            participant_country_id: self.person.country_id,
            participant_address: self.person.address,
            participant_cp: self.person.cp,
            participant_city: self.person.city,
            participant_state: self.person.state,
            participant_phone: self.person.phone,
            participant_mobile: self.person.mobile,
            participant_phone2: self.person.phone2,
            participant_email: self.person.email,
            // participant_observations:       self.person.observations,
            participant_medicament: self.person.medicamento,
            participant_alergy:
              self.person.alergy.length == 1 && self.person.alergy[0] == "null"
                ? []
                : self.person.alergy,
            participant_swim: self.person.swim == "1" ? 1 : 0,
            participant_height: self.person.height,
            participant_bus:
              self.person.transport && self.person.transport == "1"
                ? self.person.bus
                : 0,
            participant_pickup:
              self.person.transport && [1, 3].includes(self.person.bus)
                ? self.person.pickup
                : 0,
            participant_returnit:
              self.person.transport && [2, 3].includes(self.person.bus)
                ? self.person.returnit
                : 0,
            participant_how_meet: self.person.how_meet,
            participant_language: self.person.language,
            participant_information: self.information ? 1 : 0,
            legal_guardian_name: self.legal_guardian.name,
            legal_guardian_surname: self.legal_guardian.surname,
            legal_guardian_dni: self.legal_guardian.dni,
            legal_guardian_document_type: self.legal_guardian.document_type,
            participant_lottery: self.person.lottery ? 1 : 0,
            participant_payment_type: self.person.payment_type,
            participant_brothers_discount: self.person.brothers_discount
              ? 1
              : 0,
            discounts: Object.keys(self.person.total_discounts),
            services: Object.keys(self.person.services),
            total_price: parseFloat(self.main_price) + parseFloat(self.total),
            participant_other_allergies: self.person.other_allergies,
            participant_goalkeeper: self.person.goalkeeper,
            participant_diet: self.person.diet,
          })
          .then(function (response) {
            // redirect to mic api
            let oParams = self.$store.getters["getRedsysParams"];
            // window.top.location = process.env.VUE_APP_API_URL + 'form/goToRedsys/' + oParams.budget_id+ '/' + oParams.transaction_id ;

            window.top.location = oParams;
            self.$overlay.hide();
            self.button_dissabled = false;
          })
          .catch(() => {
            self.$overlay.hide();
          });

        self.button_dissabled = false;
      } else {
        this.error.form = true;
      }
    },

    removeAlergy(item) {
      let index = this.person.alergy.indexOf(item.id);
      if (index >= 0) {
        let aux = JSON.parse(JSON.stringify(this.person.alergy));
        aux.splice(index, 1);
        this.person.alergy = aux;
      }
      this.checkAlergies();
    },

    removeWeek(item) {
      let index = this.person.weeks.indexOf(item.id);
      if (index >= 0) {
        let aux = JSON.parse(JSON.stringify(this.person.weeks));
        aux.splice(index, 1);
        this.person.weeks = aux;
      }
    },

    openDialog(e) {
      this.dialog = true;
      setTimeout(function () {
        // alert( e.pageX + " " + e.pageY + " " + document.getElementById( 'popup1' ).offsetHeight )
        console.log(
          e.pageY,
          document.getElementById("popup1").offsetHeight,
          e.pageY - document.getElementById("popup1").offsetHeight
        );
        document.getElementsByClassName("v-dialog__content")[0].style.top =
          "800px"; // e.pageY - document.getElementById( 'popup1' ).offsetHeight
        document.getElementsByClassName("v-dialog__content")[0].style.position =
          "absolute";
      }, 200);
    },

    closeDialog() {
      this.dialog = false;
    },

    personPhone(input, oResult) {
      this.person.phone_aux = oResult;
    },

    personMobile(input, oResult) {
      this.person.mobile_aux = oResult;
    },

    personPhone2(input, oResult) {
      this.person.phone2_aux = oResult;
    },

    applyDiscount() {
      if (!isEmpty(this.person.discount)) {
        // remove discount errors
        this.error.duplicated_discount_code = false;
        this.error.invalit_discount_code = false;

        // variable with total_discounts
        let total_discounts = Object.keys(this.person.total_discounts).length;

        // if brothers_discount is checked, augment total discounts
        if (this.person.brothers_discount) total_discounts++;

        // if repeter_discount is checked, augment total discounts
        if (this.person.repeater_discount) total_discounts++;

        // validate total discounts (max 2 discounts)
        if (total_discounts < 2) {
          // discount
          let campus_type = "";
          for (var k in this.campus_types) {
            this.person.weeks.forEach((week) => {
              if (Object.keys(this.campus_types[k].weeks).includes(week)) {
                campus_type = k;
              }
            });
          }

          var self = this;
          this.$store
            .dispatch("checkDiscount", {
              event_id: this.$route.params.event_id,
              code: this.person.discount,
              campus_type: campus_type,
              weeks: this.person.weeks.toString(),
              modality: this.person.modality,
            })
            .then(function () {
              // get result
              let result = self.$store.getters["getPromotionalCode"];
              if (result.status) {
                var discount = self.discounts[result.data.discount_id];

                // valit code
                if (
                  result.status &&
                  ((discount.name == "nikecamp.discounts.NCnikeand2020" &&
                    parseFloat(self.person.modality) == 1) ||
                    discount.name != "nikecamp.discounts.NCnikeand2020") &&
                  ((discount.name == "nikecamp.discounts.NCAndBkt" &&
                    parseFloat(self.person.modality) == 1) ||
                    discount.name != "nikecamp.discounts.NCAndBkt")
                ) {
                  // valit code
                  if (
                    !self.person.total_discounts.hasOwnProperty(
                      result.data.discount_id
                    )
                  ) {
                    // save discount
                    self.person.total_discounts[result.data.discount_id] =
                      result.data;
                    // remove discount from input
                    self.person.discount = "";
                    if (discount.name == "nikecamp.discounts.beca") {
                      console.log("Apply Discount - BECA");
                      self.beca = true;
                      self.total = self.main_price * -1;
                    } else if (discount.name == "nikecamp.discounts.repeater") {
                      var disc = self.person.modality == 1 ? 15 : 15;
                      self.person.total_discounts[
                        result.data.discount_id
                      ].import = disc;
                      self.total = parseFloat(self.total) - disc;
                    } else {
                      self.total =
                        parseFloat(self.total) + parseFloat(result.data.import);
                    }
                    // duplicated code
                  } else {
                    self.error.duplicated_discount_code = true;
                  }
                  // invalit code
                } else {
                  self.error.invalit_discount_code = true;
                }
              } else {
                self.error.invalit_discount_code = true;
              }
            });
          // valit code, show worning
        } else {
          this.error.limit_discounts_code = true;
        }
      }
    },

    validateDuplicatedWeeks() {
      // first loop for weeks
      for (let i in this.person.weeks) {
        // get week one
        let week = this.nike_weeks[this.person.weeks[i]];
        // second loop for weeks
        for (let n in this.person.weeks) {
          // get second week
          let week2 = this.nike_weeks[this.person.weeks[n]];
          // validate if selected two weeks with the same first date
          if (week.first_date == week2.first_date && week.id != week2.id) {
            // incorrect
            return false;
          }
        }
      }
      // ok
      return true;
    },

    brotherDiscount() {
      // validate discounts length
      if (Object.keys(this.person.total_discounts).length < 2) {
        // add brothers_discount
        this.person.brothers_discount
          ? // add brother discount
            this.person.modality == 1
            ? (this.total =
                parseFloat(this.total) + this.brother_boarder.value * -1)
            : (this.total =
                parseFloat(this.total) + this.brother_no_boarder.value * -1)
          : // removed brother discount
          this.person.modality == 1
          ? (this.total = parseFloat(this.total) + this.brother_boarder.value)
          : (this.total =
              parseFloat(this.total) + this.brother_no_boarder.value);
      }
    },

    modalityChange() {
      // check if selected borther_discount
      if (Object.keys(this.person.total_discounts) > 0) {
        Object.values(this.person.total_discounts).forEach((discount) => {
          console.log("change modality - discount: ", discount);
          this.total =
            parseFloat(this.total) +
            parseFloat(discount.import) * (discount.import > 0 ? 1 : -1);
        });
      }
      this.person.total_discounts = {};
      if (this.person.brothers_discount) {
        if (this.person.modality == 1) {
          this.total = parseFloat(this.total) + this.brother_boarder.value;
        } else {
          this.total = parseFloat(this.total) + this.brother_no_boarder.value;
        }
        this.person.brothers_discount = false;
      }
      this.total = 0;
    },

    deleteDiscount(discount) {
      console.log(discount);
      // copy object
      var result = { ...this.person.total_discounts };
      // remove discount
      delete result[discount.discount_id];

      // save result to total discounts
      this.person.total_discounts = result;
      // remove limit discounts error
      this.error.limit_discounts_code = false;

      if (discount.import == -99999) {
        this.beca = false;
        // restore price
        this.total = 0;
        for (var k in result) {
          this.total -= result[k].import;
        }
        this.brotherDiscount();
      } else if (discount.code.toLowerCase() == "#andccamprep2021%") {
        console.log(this.total, this.person.modality == 1 ? 25 : 20);
        this.total =
          parseFloat(this.total) + (this.person.modality == 1 ? 25 : 20);
      } else {
        // restore price
        this.total =
          parseFloat(this.total) +
          parseFloat(discount.import) * (discount.import > 0 ? 1 : -1);
      }
    },

    calculatePrice() {
      console.log("Calculate Price");
      this.main_price = 0;
      this.person.services = {};
      this.football_sport = true;

      // validate football
      if (
        Object.values(this.person.weeks).indexOf(
          Object.keys(this.campus_types["campus.miccamp_en"].weeks)[0]
        ) > -1 ||
        Object.values(this.person.weeks).indexOf(
          Object.keys(this.campus_types["campus.miccamp_en"].weeks)[1]
        ) > -1
      ) {
        this.football_sport = true;

        if (this.person.modality == 1) {
          for (let i in this.services) {
            if (this.services[i].name == "nikecamp.services.football_int_1t_en") {
              this.main_price =
                parseFloat(this.main_price) +
                parseFloat(this.services[i].import);
              this.person.services[this.services[i].id] = this.services[i].id;
            }
          }
          // no boarder
        } else {
          for (let i in this.services) {
            if (this.services[i].name == "nikecamp.services.football_ext_1t_en") {
              this.main_price =
                parseFloat(this.main_price) +
                parseFloat(this.services[i].import);
              this.person.services[this.services[i].id] = this.services[i].id;
            }
          }
        }
      }

      // validate basket
      if (
        this.campus_types["campus.basket"] &&
        Object.values(this.person.weeks).indexOf(
          Object.keys(this.campus_types["campus.basket"].weeks)[0]
        ) > -1
      ) {
        // boarder
        if (this.person.modality == 1) {
          for (let i in this.services) {
            if (this.services[i].name == "nikecamp.services.basketball_int") {
              this.main_price =
                parseFloat(this.main_price) +
                parseFloat(this.services[i].import);
              this.person.services[this.services[i].id] = this.services[i].id;
            }
          }
          // no boarder
        } else {
          for (let i in this.services) {
            if (this.services[i].name == "nikecamp.services.basketball_ext") {
              this.main_price =
                parseFloat(this.main_price) +
                parseFloat(this.services[i].import);
              this.person.services[this.services[i].id] = this.services[i].id;
            }
          }
        }
      }

      // validate futsal
      //   if (
      //     Object.values(this.person.weeks).indexOf(
      //       Object.keys(this.campus_types["campus.futsal"].weeks)[0]
      //     ) > -1
      //   ) {
      //     // check sport sport
      //     this.football_sport = true;

      //     // boarder
      //     if (this.person.modality == 1) {
      //       for (let i in this.services) {
      //         if (this.services[i].name == "nikecamp.services.futsal_int") {
      //           this.main_price =
      //             parseFloat(this.main_price) +
      //             parseFloat(this.services[i].import);
      //           this.person.services[this.services[i].id] = this.services[i].id;
      //         }
      //       }
      //       // no boarder
      //     } else {
      //       for (let i in this.services) {
      //         if (this.services[i].name == "nikecamp.services.futsal_ext") {
      //           this.main_price =
      //             parseFloat(this.main_price) +
      //             parseFloat(this.services[i].import);
      //           this.person.services[this.services[i].id] = this.services[i].id;
      //         }
      //       }
      //     }
      //   }

      // check weeks length
      if (this.person.weeks.length > 1) {
        // repeaters discounts
        // let total_discounts = 0;

        // // get total discounts
        // total_discounts += Object.keys(this.person.total_discounts).length;

        // // check brother discount
        // if(this.person.brothers_discount) total_discounts++;

        // // get repeater discount
        // if(total_discounts < 2 && !this.person.repeater_discount){
        //     // mark repeter_dicount
        //     this.person.repeater_discount = true;
        //     // save discount to total
        //     this.total += this.repeater.value*-1;
        // }
        if (this.person.modality == 1) {
          for (let i in this.services) {
            if (this.services[i].name == "nikecamp.services.football_int_2t") {
              this.main_price = parseFloat(this.services[i].import);
              this.person.services = {};
              this.person.services[this.services[i].id] = this.services[i].id;
            }
          }
          // no boarder
        } else {
          for (let i in this.services) {
            if (this.services[i].name == "nikecamp.services.football_ext_2t") {
              this.main_price = parseFloat(this.services[i].import);
              this.person.services = {};
              this.person.services[this.services[i].id] = this.services[i].id;
            }
          }
        }
      }

      //bus
      if (this.person.transport == "1" && this.person.bus) {
        for (let i in this.services) {
          if (
            [3].includes(this.person.bus) &&
            this.services[i].name == "nikecamp.services.bus_2"
          ) {
            this.total -= this.import_bus;
            this.total += parseFloat(this.services[i].import);
            this.import_bus = parseFloat(this.services[i].import);
            this.person.services[this.services[i].id] = this.services[i].id;
          } else if (
            [1, 2].includes(this.person.bus) &&
            this.services[i].name == "nikecamp.services.bus_1"
          ) {
            this.total -= this.import_bus;
            this.total += parseFloat(this.services[i].import);
            this.import_bus = parseFloat(this.services[i].import);
            this.person.services[this.services[i].id] = this.services[i].id;
          }
        }
      } else if (this.person.transport == "2") {
        this.total -= this.import_bus;
        this.import_bus = 0;
        // for (let i in this.person.services) {
        //   console.log(
        //     "SERVICE NAME",
        //     this.services[this.person.services[i]].name,
        //     i
        //   );
        //   if (
        //     ["nikecamp.services.bus_1", "nikecamp.services.bus_2"].includes(
        //       this.services[this.person.services[i]].name
        //     )
        //   ) {
        //     this.total -= this.import_bus;
        //     this.import_bus = 0;
        //     delete this.person.services[i];
        //   }
        // }
        this.person.pickup = false;
        this.person.returnit = false;
        this.person.bus = false;
      }

      if (this.person.weeks.length < 2 && this.person.repeater_discount) {
        // remove repeater discount
        this.person.repeater_discount = false;
        // remove value from total
        this.total += this.repeater.value;
      }

      if (this.validateDuplicatedWeeks()) {
        this.error.person.weeks = false;
        this.error.duplicated_weeks = false;
      } else {
        this.error.person.weeks = true;
        this.error.duplicated_weeks = true;
      }

      if (this.beca) {
        this.total = this.main_price * -1;
      }
    },

    checkAlergies() {
      if (this.person.alergy.length > 0) {
        var pos = this.person.alergy.indexOf("null");
        if (pos >= 0) this.person.alergy.splice(pos, 1);
      } else {
        this.person.alergy.push("null");
      }
    },

    onlyNumber(evt) {
      if (!Number.isInteger(parseFloat(evt.key))) {
        evt.preventDefault();
      }
    },

    formatBirthday() {
      this.person.parsedBirthday = moment(this.person.birthday).format(
        "DD/MM/YYYY"
      );
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },

    validateYear() {
      let validate = true;

      // get participant birthday
      let person_birthday = moment(this.person.birthday).format("DD/MM/YYYY");

      // loop for each campus week
      for (let i in this.person.weeks) {
        // get campus dates

        let campus_first_date =
          this.nike_weeks[this.person.weeks[i]].first_date;
        let campus_last_date = this.nike_weeks[this.person.weeks[i]].last_date;

        // validate year
        if (
          moment(campus_first_date, "DD/MM/YYYY").year() -
            moment(person_birthday, "DD/MM/YYYY").year() >=
            this.min_age_sport() &&
          moment(campus_last_date, "DD/MM/YYYY").year() -
            moment(person_birthday, "DD/MM/YYYY").year() <=
            this.max_age_sport() + 1
        ) {
          // validate min_age
          if (
            moment(campus_first_date, "DD/MM/YYYY").year() -
              moment(person_birthday, "DD/MM/YYYY").year() ==
            this.min_age_sport()
          ) {
            // validate smaller month
            if (
              moment(campus_last_date, "DD/MM/YYYY").month() +
                1 -
                (moment(person_birthday, "DD/MM/YYYY").month() + 1) <
              0
            ) {
              validate = false;
            }

            // validate same month
            if (
              moment(campus_last_date, "DD/MM/YYYY").month() +
                1 -
                (moment(person_birthday, "DD/MM/YYYY").month() + 1) ==
              0
            ) {
              console.log(
                moment(campus_last_date, "DD/MM/YYYY").date() -
                  moment(person_birthday, "DD/MM/YYYY").date()
              );

              // day bigger than campus, invalid
              if (
                moment(campus_last_date, "DD/MM/YYYY").date() -
                  moment(person_birthday, "DD/MM/YYYY").date() <
                0
              ) {
                validate = false;
              }
            }
          }

          // validate max_age
          if (
            moment(campus_last_date, "DD/MM/YYYY").year() -
              moment(person_birthday, "DD/MM/YYYY").year() ==
            this.max_age_sport() + 1
          ) {
            // validate first day from campus (MONTH)
            if (
              moment(campus_first_date, "DD/MM/YYYY").month() +
                1 -
                (moment(person_birthday, "DD/MM/YYYY").month() + 1) >
              0
            ) {
              validate = false;
            }

            // validate first day from campus (DAY)
            if (
              moment(campus_last_date, "DD/MM/YYYY").month() +
                1 -
                (moment(person_birthday, "DD/MM/YYYY").month() + 1) ==
              0
            ) {
              // validate peron day with the last day of the campus
              if (
                moment(campus_last_date, "DD/MM/YYYY").date() -
                  moment(person_birthday, "DD/MM/YYYY").date() >=
                0
              ) {
                validate = false;
              }
            }
          }
        } else {
          validate = false;
        }
      }

      return validate;
    },

    min_age_sport() {
      var sport =
        Object.keys(this.person.services).length > 0
          ? this.services[Object.keys(this.person.services)[0]].name.match(
              "football"
            ) ||
            this.services[Object.keys(this.person.services)[0]].name.match(
              "futbol"
            )
            ? "football"
            : "basket"
          : "football";
      if (Object.keys(this.person.services).length > 0) {
        console.log(
          "min_age_sport",
          sport,
          this.services[Object.keys(this.person.services)[0]].name,
          this.min_age[sport]
        );
      } else {
        console.log("min_age_sport", sport, this.min_age[sport]);
      }
      return this.min_age[sport];
    },

    max_age_sport() {
      var sport =
        Object.keys(this.person.services).length > 0
          ? this.services[Object.keys(this.person.services)[0]].name.match(
              "football"
            ) ||
            this.services[Object.keys(this.person.services)[0]].name.match(
              "futbol"
            )
            ? "football"
            : "basket"
          : "football";
      if (Object.keys(this.person.services).length > 0) {
        console.log(
          "max_age_sport",
          sport,
          this.services[Object.keys(this.person.services)[0]].name,
          this.max_age[sport]
        );
      }
      return this.max_age[sport];
    },
  },

  computed: {
    cssProps() {
      return {
        "background-color": this.$store.getters["getEventColor"],
      };
    },
    cssButton() {
      return {
        background: this.$store.getters["getEventColor"],
      };
    },
    politicaPrivacidad() {
      switch (this.lang) {
        case "ca":
          return (
            "https://miccamp.com/wp-content/uploads/2025/02/MC25_PoliticaPrivacitat_CAT.pdf?" +
            moment().valueOf()
          );
        case "es":
          return (
            "https://miccamp.com/wp-content/uploads/2025/02/MC25_PoliticaPrivacidad_ESP.pdf?" +
            moment().valueOf()
          );
      }
      return false;
    },
  },

  watch: {
    football_sport: function () {
      this.football_sport
        ? (this.person.goalkeeper = "")
        : (this.person.goalkeeper = "");
    },

    "person.parsedBirthday": function () {
      if (moment(this.person.parsedBirthday, "DD/MM/YYYY").isValid()) {
        this.person.birthday = moment(
          this.person.parsedBirthday,
          "DD/MM/YYYY"
        ).format("YYYY-MM-DD");
      }
    },
  },
};
</script>
<style lang="scss">
// iframe
body {
  //overflow: hidden
}

body::-webkit-scrollbar {
  width: 0;
}

#nike-form {
  background-color: #fff;
  margin: 0;
  padding: 5px;
  height: 100%;

  .error-form {
    margin: 0 auto;
    display: block;
    text-align: center;
    font-weight: bold;
    font-size: 16px;
  }

  .obligatory {
    color: $alert-color !important;
    font-weight: bold !important;
  }

  .clickable {
    margin-left: 10px;
    color: $alert-color !important;
    font-weight: bold !important;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }

  hr {
    background-color: #ccc;
    margin: 30px auto;
    width: 95%;
    background-color: transparent;
  }

  h2,
  h3,
  h4,
  h6 {
    // font-family: AvantGarde-Bold;
    color: $main-color !important;
    text-transform: uppercase;
  }

  h3 {
    font-size: 24px;
    background: #172654;
    color: #fff !important;
    padding: 4px;
  }

  h5 {
    font-weight: normal;
    // font-family: Roboto;
  }

  h6 {
    font-size: 18px;
    background: #eee;
    color: #999 !important;
    padding: 8px;
  }

  .alert {
    background-color: #e5faff;
    padding: 15px;
    width: 98%;
    margin: 20px auto;
    font-size: 16px;
  }

  .container.fluid.grid-list-md {
    padding: 0;
  }

  h2 {
    text-align: center;
    text-transform: uppercase;
    font-style: italic;
    // font-family: AvantGarde-Bold;
  }

  .v-menu__content {
    margin-top: 43px;

    * {
      text-decoration: none !important;
    }
  }

  a {
    text-decoration: underline;
    cursor: pointer;
    font-weight: bold;
    // font-family: AvantGarde-Bold;
  }

  .box {
    width: 100%;
    margin: 0 auto;
    height: auto;
    overflow: auto;
    text-align: center;
    // font-family: AvantGarde-Bold;

    .message.error {
      color: $warning-color;
      // font-family: AvantGarde-Bold;
    }

    label {
      font-family: AvantGarde-Bold;
      font-size: 14px;
      margin-bottom: 3px;
      // padding: 0;
      // margin-bottom: 5px;
      display: block;
      color: black;
      font-weight: bold;
    }

    #country {
      .v-input {
        border: none;
      }
    }

    .item {
      width: calc(50% - 40px);
      margin: 10px 20px;
      display: inline-block;
      vertical-align: top;

      input,
      select,
      .v-autocomplete .v-input__slot,
      textarea,
      .v-select {
        width: 100%;
        padding: 5px 6px;
        margin-bottom: 0;
        border: 1px solid $main-color;
        outline: none;
        font-size: 11pt;
        border-radius: 3px;
        color: $dark-color;
        // font-family: Roboto-Light;
        // font-weight: lighter;

        &::placeholder {
          color: $dark-color;
          // font-family: Roboto-Light;
          // font-weight: lighter;
          opacity: 0.5;
        }

        &.shadow:focus {
          border-color: #66afe9;
          outline: 0;
          border-left: 6px solid #66afe9;
        }
      }

      .discount {
        padding: 5px 6px;
        margin-bottom: 0;
        border: 1px solid $main-color;
        outline: none;
        font-size: 11pt;
        border-radius: 3px;
        color: $dark-color;
        background: #000 !important;
        color: $secondary-color;
        &:hover {
          background: rgb(255, 70, 0);
        }
      }

      .v-autocomplete,
      .v-select {
        margin-top: 0;
        padding-top: 0;
        font-family: AvantGarde-Bold;
        .v-input__control {
          font-family: AvantGarde-Bold;
          .v-input__slot {
            margin: 0;
            padding: 0;

            &:after,
            &:before {
              content: "";
              border: none !important;
              font-family: AvantGarde-Bold;
            }
          }
          .v-select__slot {
            border: none;
            font-family: AvantGarde-Bold;
            // padding: 5px 12px;
            padding: 0;
            input {
              border: none;
              margin: 0;
            }
          }
        }
      }

      .error {
        border-color: red !important;

        &::placeholder {
          color: $alert-color !important;
          opacity: 1;
        }

        .v-input__slot {
          border-color: $alert-color;
        }

        .vti__input {
          border-color: red !important;
        }
      }

      .date-picker.error {
        input {
          border: 1px solid red;
        }
      }

      .upper {
        text-transform: uppercase;
      }

      span {
        color: black;
        font-size: 16px;

        &.info {
          font-weight: bold;
          color: #cb880a !important;
        }
      }

      input[type="number"] {
        -moz-appearance: textfield;
      }

      input::-webkit-outer-spin-button,
      input::-webkit-inner-spin-button {
        -webkit-appearance: none;
      }

      select {
        background-image: url("/img/sort-down.svg");
        background-size: 10px;
        background-position: right 10px center;
        background-repeat: no-repeat;
        // font-family: AvantGarde-Bold;
      }

      select option {
        font-size: 14pt;
      }

      .v-input__slot {
        margin: 0;
      }
    }

    #alergy {
      .v-text-field__details {
        display: none !important;
      }
    }

    #birthday {
      .error {
        input {
          border: 1px solid red;
        }
      }
      /*
                input {
                    border: 1px solid red;
                }
                */
    }

    #price {
      background-color: #ddd;
      padding: 20px;

      .row {
        width: 100%;
        margin: 5px 0;
        overflow: hidden;

        .name {
          font-size: 16px;
          b {
            text-transform: uppercase;
            font-weight: bold;
            font-family: Roboto-Bold;
          }
        }
        .clickable {
          font-size: 14px;
          margin-left: 10px;
        }
        .value {
          font-weight: bold;
          font-size: 20px;
          float: right;
        }

        &.total {
          border-top: 1px solid rgba(0, 0, 0, 0.5);
          padding-top: 10px;
          margin-top: 10px;
          font-family: Roboto-Bold;

          .name,
          .value {
            font-family: Roboto-Bold;
            // text-transform: uppercase;
            font-size: 24px;
          }
        }
      }
      h5,
      span {
        display: inline-block;
        height: 100%;
        margin: 0;
        padding: 0;
        vertical-align: middle;
      }

      h5 {
        margin-right: 20px;
      }

      span {
        font-weight: bold;
        // color: $main-color;
        font-size: 40px;
      }
    }

    #discounts-list {
      ul {
        li {
          list-style-type: circle;
        }
      }
    }

    .terms_and_conditions {
      margin: 0;
      display: inline-block;
    }

    .information {
      border: 1px solid $secondary-color;
      margin-left: 10px;
      padding: 10px;
    }

    #send {
      max-width: 300px;
      width: 100%;
      padding: 15px;
      outline: none;
      border: none;
      cursor: pointer;
      font-size: 12pt;
      font-family: AvantGarde-Bold;
      margin-top: 5px;
      border-radius: 3px;
      border: 1px solid $secondary-color;
      text-transform: uppercase;
      transition: all 0.5s;
      background: #000022;
      color: $secondary-color;

      &:hover {
        background-color: rgb(255, 70, 0) !important;
      }
    }
  }
}

@media (max-width: 720px) {
  #nike-form {
    .box {
      .item {
        width: calc(100% - 20px);
      }
    }
  }
}

@include media(">phone", "<tablet") {
  #nike-form {
    .box {
      .item {
        margin: 0 !important;
      }
    }
  }
}
</style>
